import React from 'react';
export function ResultsSlide() {
  const statistics = [{
    label: 'Alcance promedio',
    value: '18,541'
  }, {
    label: 'Interacciones',
    value: '988'
  }, {
    label: 'Tasa de engagement',
    value: '5.3%'
  }];
  const benefits = ['Captura la atención de usuarios en redes sociales y transmite rápidamente la esencia única de tu destino turístico.', 'Muestra tu marca de forma auténtica y creativa.', 'Te diferencia de la competencia y atrae más clientes y reservas para tu negocio turístico.'];
  return <div className="w-full bg-white" data-id="element-1080">
      <div className="max-w-5xl mx-auto" data-id="element-1081">
        <div className="flex flex-col md:flex-row gap-12" data-id="element-1082">
          <div className="w-full md:w-2/3" data-id="element-1083">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1084">
              "De compartidos, me gusta y comentarios a ventas y reservaciones."
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-1085">
              {statistics.map((stat, index) => <div key={index} className="bg-gray-50 p-6 rounded-lg" data-id="element-1086">
                  <p className="text-3xl font-normal text-black mb-2" data-id="element-1087">
                    {stat.value}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-1088">{stat.label}</p>
                </div>)}
            </div>
            <div className="grid grid-cols-3 gap-6 mb-12" data-id="element-1089">
              <div className="aspect-[9/16] rounded-lg overflow-hidden" data-id="element-1090">
                <img src="https://images.unsplash.com/photo-1589394815804-964ed0be2eb5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" alt="Estadísticas de engagement" className="w-full h-full object-cover" data-id="element-1091" />
              </div>
              <div className="aspect-[9/16] rounded-lg overflow-hidden" data-id="element-1092">
                <img src="https://images.unsplash.com/photo-1589395937772-f67057e233df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" alt="Estadísticas de engagement" className="w-full h-full object-cover" data-id="element-1093" />
              </div>
              <div className="aspect-[9/16] rounded-lg overflow-hidden" data-id="element-1094">
                <img src="https://images.unsplash.com/photo-1589396575653-c09c794ff6a6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" alt="Estadísticas de engagement" className="w-full h-full object-cover" data-id="element-1095" />
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1096">
              <div className="flex items-center justify-between mb-4" data-id="element-1097">
                <div className="flex items-center" data-id="element-1098">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1099">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" data-id="element-1100" />
                  </svg>
                  <span className="text-base font-medium text-black" data-id="element-1101">
                    Datos desde 7 de octubre de 2023
                  </span>
                </div>
                <div data-id="element-1102">
                  <span className="text-2xl font-normal text-black" data-id="element-1103">231K</span>
                </div>
              </div>
              <div className="h-2 bg-gray-200 rounded-full mb-4" data-id="element-1104">
                <div className="h-full bg-black rounded-full" style={{
                width: '85%'
              }} data-id="element-1105"></div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/3" data-id="element-1106">
            <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-1107">
              <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-6" data-id="element-1108">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t9AcqBTZc97z7oLWTJi33G/unnamed_%284%29.png" alt="Fran" className="w-full h-full object-cover" data-id="element-1109" />
              </div>
            </div>
            <h3 className="text-xl font-medium text-black mb-6" data-id="element-1110">
              Crear contenido atractivo es crucial porque:
            </h3>
            <ul className="space-y-6" data-id="element-1111">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-1112">
                  <span className="mr-2 text-black" data-id="element-1113">•</span>
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-1114">
                    {benefit}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}